export default () => ({
  roboto: 'https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap',
  'open sans': 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap',
  lato: 'https://fonts.googleapis.com/css2?family=Lato:wght@300&display=swap',
  slabo: ' https://fonts.googleapis.com/css2?family=Slabo+27px&display=swap',
  oswald: 'https://fonts.googleapis.com/css2?family=Oswald:wght@300&display=swap',
  'source sans pro': 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300&display=swap',
  montserrat: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap',
  raleway: 'https://fonts.googleapis.com/css2?family=Raleway:wght@300&display=swap',
  'pt sans': 'https://fonts.googleapis.com/css2?family=PT+Sans&display=swap',
  lora: 'https://fonts.googleapis.com/css2?family=Lora&display=swap',
  'noto sans': 'https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap',
  prompt: 'https://fonts.googleapis.com/css2?family=Prompt:wght@300&display=swap',
  alegreya: 'https://fonts.googleapis.com/css2?family=Alegreya&display=swap',
  'roboto slab': 'https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap',
  ubuntu: 'https://fonts.googleapis.com/css2?family=Ubuntu&display=swap',
  b612: 'https://fonts.googleapis.com/css2?family=B612&display=swap',
  titillium: 'https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap',
  varela: 'https://fonts.googleapis.com/css2?family=Varela&display=swap',
  vollkom: 'https://fonts.googleapis.com/css2?family=Vollkorn&display=swap',
  'ibm plex': 'https://fonts.googleapis.com/css2?family=IBM+Plex+Serif&display=swap',
  crimson: 'https://fonts.googleapis.com/css2?family=Crimson+Text&display=swap',
  cairo: 'https://fonts.googleapis.com/css2?family=Cairo&display=swap',
  karla: 'https://fonts.googleapis.com/css2?family=Karla&display=swap',
  archivo: 'https://fonts.googleapis.com/css2?family=Archivo&display=swap',
  spectral: 'https://fonts.googleapis.com/css2?family=Spectral&display=swap',
  rubik: 'https://fonts.googleapis.com/css2?family=Rubik&display=swap'
})
